import { VStack } from "@chakra-ui/react";
import { Field, FormInput, FormSelect, FormTextarea, CollapsibleSection, Grid2, isFieldInvalid, isFieldWarning } from "@/components/jobOffer/ui";
import { CAMPAIGN_LANGUAGE_OPTIONS, CAMPAIGN_LANGUAGE_AUTO_VALUE } from "@/components/campaign/campaignLanguageOptions";

const CAMPAIGN_LANGUAGE_VALUES = new Set(CAMPAIGN_LANGUAGE_OPTIONS.map((o) => o.value));

const Step1Campaign = ({ formik, values, setValues, warningErrors, visited, forceOpen }) => {
    const set = (key, val) => setValues({ ...values, [key]: val });
    const invalid = (path) => isFieldInvalid(formik, path);
    const warning = (path) => isFieldWarning(warningErrors, visited, path);

    // Old campaigns may have arbitrary free-text values from before this became a fixed dropdown --
    // filter those out here rather than passing them into FormSelect, so an unrecognized value just
    // shows up as "not selected" instead of risking the Select choking on an item outside its collection.
    const selectedLanguages = (values.languages ?? []).filter((v) => CAMPAIGN_LANGUAGE_VALUES.has(v));
    const setLanguages = (next) => {
        const hadAuto = selectedLanguages.includes(CAMPAIGN_LANGUAGE_AUTO_VALUE);
        const hasAuto = next.includes(CAMPAIGN_LANGUAGE_AUTO_VALUE);
        if (hasAuto && !hadAuto) set("languages", [CAMPAIGN_LANGUAGE_AUTO_VALUE]);
        else if (hasAuto && next.length > 1) set("languages", next.filter((v) => v !== CAMPAIGN_LANGUAGE_AUTO_VALUE));
        else set("languages", next);
    };

    return (
        <VStack w="full" align="stretch" gap={4}>
            <CollapsibleSection title="Podstawowe informacje" subtitle="Nazwa kampanii i jej wirtualnego handlowca" defaultOpen forceOpen={forceOpen}>
                <VStack align="stretch" gap={4}>
                    <Field label="Nazwa kampanii" required invalid={invalid("name")} warning={warning("name")}>
                        <FormInput value={values.name} onChange={(e) => set("name", e.target.value)} placeholder="np. MetaAds - Agenci AI - sierpień 2026" />
                    </Field>
                    <Grid2>
                        <Field label="Nazwa Handlowca AI" hint='np. "Marek - Doradca AI"'>
                            <FormInput value={values.agentDisplayName ?? ""} onChange={(e) => set("agentDisplayName", e.target.value)} />
                        </Field>
                        <Field label="Języki komunikacji">
                            <FormSelect value={selectedLanguages} onChange={setLanguages} options={CAMPAIGN_LANGUAGE_OPTIONS} placeholder="Wybierz języki" multiple />
                        </Field>
                    </Grid2>
                    <Field label="Opis kampanii" hint="Krótki opis wewnętrzny">
                        <FormTextarea value={values.description ?? ""} onChange={(e) => set("description", e.target.value)} rows={2} />
                    </Field>
                </VStack>
            </CollapsibleSection>
        </VStack>
    );
};

export default Step1Campaign;
